var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSquareIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7852 1.49805H3.78516C2.95516 1.49805 2.28516 2.16805 2.28516 2.99805V20.998C2.28516 21.828 2.95516 22.498 3.78516 22.498H21.7852C22.6152 22.498 23.2852 21.828 23.2852 20.998V2.99805C23.2852 2.16805 22.6152 1.49805 21.7852 1.49805Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSquareIndicator);
export default __webpack_public_path__ + "static/media/ic-square-indicator.a511be604e572fb25ebf475fa8b0ab27.svg";
export { ForwardRef as ReactComponent };